<app-full-screen>
  <app-wizard-header></app-wizard-header>
</app-full-screen>
<router-outlet></router-outlet>
